import Vue from "vue";
import Router from "vue-router";

import Home from "@/views/Home.vue";
import Legislacao from "@/views/Legislacao";
import Ajuda from "@/views/Ajuda";
import Contato from "@/views/Contato";
import Login from "@/views/Login";
import Credenciamento from "@/views/Credenciamento";
import Autenticidade from "@/views/Autenticidade";
import SolicitarSenha from "@/views/SolicitarSenha";
import RecuperarEmail from "@/views/RecuperarEmail";
import Api from "@/views/Api";
import Empresas from "@/views/EmpresasAutorizadas";
import SubstitutoTributario from "@/views/SubstitutoTributario";
import TabelaAtividades from '@/views/TabelaAtividades'
import Concurso from "@/views/Concurso";
import Bilhete from "@/views/Bilhete";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/legislacao",
      name: "legislacao",
      component: Legislacao
    },
    {
      path: "/ajuda",
      name: "ajuda",
      component: Ajuda
    },
    {
      path: "/contato",
      name: "contato",
      component: Contato
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/credenciamento",
      name: "Credenciamento",
      component: Credenciamento
    },
    {
      path: "/autenticidade",
      name: "Autenticidade",
      component: Autenticidade
    },
    {
      path: "/senha",
      name: "SolicitarSenha",
      component: SolicitarSenha,
    },
    {
      path: "/recuperarEmail",
      name: "RecuperarEmail",
      component: RecuperarEmail
    },
    {
      path: "/api",
      name: "API",
      component: Api
    },
    {
      path: "/empresa",
      name: "Empresas",
      component: Empresas
    },
    {
      path: "/substitutoTributario",
      name: "SubstitutoTributario",
      component: SubstitutoTributario
    },
    {
      path: "/tabela",
      name: "Tabela",
      component: TabelaAtividades
    },
    {
      path: "/concurso",
      name: "Concurso",
      component: Concurso
    },
    {
      path: "/bilhetes",
      name: "Bilhete",
      component: Bilhete
    }
  ]
});
